import {isAssetLink, type AssetLink} from '../../schemas/contentful/contentTypes/assetLink'
import {isLink, type Link} from '../../schemas/contentful/contentTypes/link'

export function getLinkHref(link: Link | AssetLink | undefined): string {
  if (isLink(link)) {
    return link.fields.href
  } else if (isAssetLink(link)) {
    return link.fields.asset?.fields.file.url || ''
  }

  return ''
}
